import React from 'react'
import {
  Grid,
  Heading,
  Body,
  Link,
  TextVerticalSpacer,
  PageSection as Section,
} from '@superhi/design'

import { Card } from './styles'

import { buildPath } from 'src/routing'

const PRESS_PATH = buildPath('press')
const ROW_GAP = { small: 16, medium: 24, large: 24, xlarge: 24 }
const COLUMN_GAP = { small: 16, medium: 24, large: 24, xlarge: 24 }
const CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 4,
  large: [3, 6],
}
const CELL_SPAN_2: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 4,
  large: 4,
}

type Props = {
  title?: string
  subtitle?: string
}

const Contact: React.FC<React.PropsWithChildren<Props>> = ({
  title = 'Get in contact',
  subtitle = "Got this far down the page and still have a question? We're pretty quick to reply to anything you wanna ask!",
}) => (
  <Section title={title} subtitle={subtitle} backgroundColor="warm-blue" headingLevel={2}>
    <Grid rowGap={ROW_GAP} columnGap={COLUMN_GAP}>
      <Grid.Cell span={CELL_SPAN_1}>
        <Card align="center" level="1" elevated={false}>
          <TextVerticalSpacer level="5">
            <Heading level="4" as={'h3'}>
              General
            </Heading>

            <Body level="3">
              <Link href="mailto:hi@superhi.com" isExternal>
                hi@superhi.com
              </Link>
            </Body>
          </TextVerticalSpacer>
        </Card>
      </Grid.Cell>

      <Grid.Cell span={CELL_SPAN_2}>
        <Card align="center" level="1" elevated={false}>
          <TextVerticalSpacer level="5">
            <Heading level="4" as={'h3'}>
              Media inquiries
            </Heading>

            <Body level="3">
              <Link href="mailto:press@superhi.com" isExternal>
                press@superhi.com
              </Link>
            </Body>

            <Body level="3">
              <Link href={PRESS_PATH}>View our press page</Link>
            </Body>
          </TextVerticalSpacer>
        </Card>
      </Grid.Cell>

      <Grid.Cell span={CELL_SPAN_1}>
        <Card align="center" level="1" elevated={false}>
          <TextVerticalSpacer level="5">
            <Heading level="4" as={'h3'}>
              Partnerships
            </Heading>

            <Body level="3">
              <Link href="mailto:rik@superhi.com" isExternal>
                rik@superhi.com
              </Link>
            </Body>
          </TextVerticalSpacer>
        </Card>
      </Grid.Cell>

      <Grid.Cell span={CELL_SPAN_2}>
        <Card align="center" level="1" elevated={false}>
          <TextVerticalSpacer level="5">
            <Heading level="4" as={'h3'}>
              Blog
            </Heading>

            <Body level="3">
              <Link href="mailto:editorial@superhi.com" isExternal>
                editorial@superhi.com
              </Link>
            </Body>

            <Body level="3">
              <Link
                href="https://www.notion.so/superhi/Writing-for-the-SuperHi-Blog-a9cf15921a6a481eb13f21975cdb81c2"
                isExternal
              >
                View submission guidelines
              </Link>
            </Body>
          </TextVerticalSpacer>
        </Card>
      </Grid.Cell>
    </Grid>
  </Section>
)

export default Contact
